import { VendorRebateCategoryProgramTiersGrowths } from '../../../components/Vendor/RebateCategories/';

export function RebateCategoryProgramTiersAndGrowths() {
  return <VendorRebateCategoryProgramTiersGrowths />;
}
